export const TYPE_APPOINTMENT_COLOR = 'rgb(249, 42, 194)';
export const TYPE_APPOINTMENT_FINISHED_COLOR = 'rgb(249, 42, 194,0.6)';
export const TYPE_APPOINTMENT_DRAFT_COLOR = 'rgb(132, 132, 132)';
export const TYPE_EVENT_COLOR = 'rgb(249, 42, 194)';
export const VIEW_WEEK = 'agendaWeek';
export const VIEW_MONTH = 'month';


// WEBPACK FOOTER //
// ./src/common/constants/agenda-types.constant.ts